<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form
    [formGroup]="greetingFormGroup"
    onsipFormTracking
    name="admin-voicemail-greeting-edit"
    id="admin-voicemail-greeting-edit"
  >
    <div class="mat-body-1 add-heading m-b-12">Add a custom greeting</div>
    <div onsip-grid-placement-shelf>
      <div class="first-column">
        <div class="mat-body-2 descriptive-greeting-text">
          To record a greeting: click the microphone to start recording your voice for a
          personalized greeting. After you finish recording, you can review the greeting
        </div>
        <div class="mat-body-2 descriptive-greeting-text">
          To upload a greeting: upload a pre-recorded wav file
        </div>
      </div>
      <div class="second-column button-toggle-group-container">
        <onsip-togglable-recorder
          formControlName="greeting"
          class="recorder"
          [hasSelect]="false"
          [hasSave]="true"
          [defaultType]="greetingType"
          (saved)="onSubmit()"
          (recordingTypeChange)="this.greetingType = $event"
        >
        </onsip-togglable-recorder>
      </div>
    </div>
    <div class="page-view-controls">
      @if (showSaveButton | async) {
      <button mat-flat-button type="button" (click)="onSubmit()" color="primary">
        {{ "ONSIP_I18N.SAVE_CHANGES" | translate }}
      </button>
      }
      <button mat-button type="button" (click)="togglePanel()" color="primary">
        {{ "ONSIP_I18N.CANCEL" | translate }}
      </button>
    </div>
  </form>
</onsip-loading-container>
